# Test card (failure): 4000000000000341

class Model
  
  properties: {}
  
  constructor: (@spec) ->
    @[prop] = val for prop, val of @properties
    @events = {}  # TODO: need way to make change default event, and add events in subclass.
    @init()
    
  init: ->  # Override in subclass
  
  set: (prop, val) ->
    @[prop] = val
    @trigger "change", {prop}
  
  on: (event, listener) -> @events[event]?.push listener
  
  onSet: (prop, listener) =>
    @on "change", (data) =>
      return unless data.prop is prop
      listener()
  
  trigger: (event, data) ->
    listeners = @events[event]
    return unless listeners
    listener(data) for listener in listeners
    
  getProps: ->
    p = {}
    p[name] = @[name] for name, val of @properties
    p


class Registration extends Model
    
  properties:
    year: null
    name: null
    email: null
    organisation: null
    address: null
    phone: null
    levy_payer: false
    discount: null
    comp: false   # Complimentary
    sector: null   # TODO: options?
    group: null
    delegates: null
    
  init: ->
    
    @events =
      change: []
      addDelegate: []
      removeDelegate: []
      changeDelegate: []
    
    {@year, @sessions, @marineFarmerLevyPayer, @isAdmin} = @spec
    
    @delegates = []
    
    @onSet "sector", => @setSector()
  
  setModel: (model) ->
    for prop, val of @properties
      @set(prop, model[prop]) unless prop is "delegates"
    @addDelegate(delegate) for delegate in model.delegates
  
  setSector: ->
    @set "levy_payer", (@sector is @marineFarmerLevyPayer)
  
  numDelegates: -> @delegates.length
  
  lastDelegate: -> _.last @delegates  #[-1..][0]
  
  addDelegate: (model=null) ->
    regModel = this
    delegate = new Delegate {@sessions, regModel, @isAdmin}  # regModel for matching contact name/email
    @delegates.push delegate
    delegate.setIndex @numDelegates()
    
    delegate.on "change", (data) => @trigger "changeDelegate", {delegate}
    @trigger "addDelegate"
    
    delegate.setModel(model) if model
    
  removeDelegate: (index) ->
    @delegates.splice(index-1, 1)
    # Reindex
    delegate.setIndex(n+1) for delegate, n in @delegates
    @trigger "removeDelegate", {index}
  
  validate: ->
    (@overDelegates "validate").every (x) -> x
    
  price: ->
    total = _.sum(@overDelegates "price") - (@discount ? 0)
    if total>=0 then total else 0
    
  getProps: ->
    p = super()
    p.delegates = @overDelegates "getProps"
    p
    
  overDelegates: (f) ->
    @delegates.map (delegate) -> delegate[f]()


class Delegate extends Model
  
  contactProps: ["name", "email"]
  
  properties:
    index: null
    name: null
    email: null
    technicalDay: false
    confDay: false  # Includes cocktail function
    cocktail: false
    dietary: null
    sameAsContact: false
  
  init: ->
    
    @events =
      change: []
      invalid: []
      
    {@sessions, @regModel, @isAdmin} = @spec
    
    @regModel.on "change", (data) =>
      @setContact(@regModel) if @sameAsContact
    
    @onSet "sameAsContact", => @setContact(if @sameAsContact then @regModel else null)
    
    # To handle confDay/technicalDay pairing
    confSet = false
    
    @pairDays = false
    #@pairDays = not @isAdmin
    
    @onSet "confDay", =>
      confSet = true
      @set("technicalDay", @confDay) if @pairDays and not @sessions.technicalDay.disabled
      confSet = false
      @set("cocktail", false) if @confDay

    @onSet "technicalDay", =>
      return if confSet or not @pairDays or @sessions.confDay.disabled
      @set("confDay", @technicalDay)
  
  setModel: (model) ->
    for prop, val of @properties
      @set(prop, model[prop]) unless prop is "sameAsContact"
    @set("sameAsContact", true) if model.sameAsContact
    
  setIndex: (@index) ->
      
  setContact: (model=null) ->
    @set prop, (model?[prop] ? "") for prop in @contactProps
  
  prices: ->
    p = {}
    type = @payerType()
    p[id] = (info.fee[type] ? info.fee) for id, info of @sessions
    p
  
  price: ->
    return 0 if @complimentary()
    _.sum((if @[session] then p else 0) for session, p of @prices())
  
  clean: ->
    clean = true
    for name, val of @properties
      continue if name is "index" or not(@[name])
      clean = false
      break
    clean
    
  remove: -> @regModel.removeDelegate @index
  
  validate: ->
    price = @price()
    valid = price>0 or @complimentary()  # TODO: admin: not quite right for comp, because could set no sessions?
    @trigger "invalid" unless valid
    valid
    
  payerType: -> if @regModel.levy_payer then "levyPayer" else "nonLevyPayer"
  
  hasLevyPayerDiscount: (session) ->
    @sessions[session].fee.levyPayer and @regModel.levy_payer
  
  complimentary: -> @regModel.comp


class Form
  
  constructor: ->
    
    @find("input, textarea, select").change (evt) =>
      input = $ evt.target
      return if input.data("not-in-model")
      id = input.attr "id"
      @model.set id, @getVal(input)
      #console.log "model", @model
    
    @model.on "change", (data) =>
      {prop} = data 
      @setVal prop, @model[prop]
      
  getVal: (input) ->
    type = @getType input
    if type in ["input", "email", "textarea", "select"]
      input.val()
    else if type is "checkbox"
      input[0].checked
    else
      null
    
  setVal: (prop, val) ->
    input = @input prop
    type = @getType input
    if type in ["input", "email", "textarea", "select"]
      input.val(val)
    else if type is "checkbox"
      input.prop "checked", val
      
  getType: (input) -> input.attr("type") ? input.prop("tagName")?.toLowerCase()
  
  input: (id) -> @find("input##{id}, textarea##{id}, select##{id}")
  
  label: (id) -> @input(id).closest("label")  # Works only for checkboxes?
  
  disable: (id, disable=true) -> @input(id).attr "disabled", disable
  


class RegistrationForm extends Form
  
  form: $ ".registration-form .registration-details"
  allFormsSel: ".conference-form"
  addDelegateButton: $ ".add-delegate"
  registerButton: $ ".register-button"
  total: $ ".registration-total"
  
  constructor: (@spec) ->
    
    {@model, @register, @buttonLabel} = @spec
    
    @registerButton.html(@buttonLabel) if @buttonLabel
    
    @delegateForms = []
    
    @addDelegateButton.find("button").click => @model.addDelegate()
    
    @model.on "addDelegate", => @addDelegate()
    
    @model.on "removeDelegate", (data) => @removeDelegate(data.index)
    
    @model.on "changeDelegate", => @setTotal()
    
    @model.onSet "comp", =>
      @model.set("discount", "") if @model.comp
      @setTotal()
      
    @model.onSet "discount", =>
      
      d = @model.discount
      unless not(d) or Number(d)
        d = d.replace /[^0-9]/g, ""
        @model.set "discount", d
        return
      
      @model.set("comp", false) if @model.discount
      @setTotal()
    
    @registerButton.click (e) =>
      @register() if @validate()
      e.preventDefault()
    
    super()
    
  addDelegate: ->
    form = new DelegateForm {model: @model.lastDelegate()}
    @delegateForms.push form
    @addDelegateButton.show()  # TODO: if hidden
    
    # Select both days by default
    d = @model.lastDelegate()
    sessions = @model.sessions
    d.set("confDay", true) unless sessions.confDay.disabled
    d.set("technicalDay", true) unless sessions.technicalDay.disabled
    
  removeDelegate: (index) ->
    form = @delegateForms[index-1]
    form.remove()
    @delegateForms.splice(index-1, 1)
    # Reindex
    form.setIndex() for form in @delegateForms
  
  validate: ->
    
    allForms = $ @allFormsSel
    validForms = true
    
    for form in allForms
      validForms = form.checkValidity()
      unless validForms
        form.reportValidity()
        break
    
    @model.validate() and validForms
    
  find: (sel) -> @form.find(sel)
  
  setTotal: -> @total.html "Total: $"+@model.price().toFixed(2)


class DelegateForm extends Form
  
  containerSel: ".delegates"
  template: _.tmpl "#delegate-tmpl"
  removeButtonSel: ".remove-delegate"
  
  constructor: (@spec) ->
    
    {@model} = @spec
    
    @container = $ @containerSel
    @delegate = $(@template @model).appendTo @container
    
    @removeButton = @find @removeButtonSel
    @removeButton.show() unless @model.index is 1
    
    @setPrices()
    @setDisabled()
    
    @input("sameAsContact").change (evt) =>
      @model.set "sameAsContact", @getVal($ evt.target)
      
    @model.onSet "sameAsContact", =>
      isSame = @model.sameAsContact
      @disable "name", isSame
      @disable "email", isSame
    
    @model.onSet "confDay", =>
      disable = @model.confDay or @model.sessions.cocktail.disabled
      @disable "cocktail", disable
      @label("cocktail")[if disable then "addClass" else "removeClass"]("fade-label")
    
    @model.regModel.onSet "levy_payer", =>
      @setPrices()
      @model.trigger "change", {}
    
    @model.on "change", (data) =>
      show = @model.index isnt 1  # @model.clean() and @model.index isnt 1
      @removeButton[if show then "show" else "hide"]()
      @showInstruction(false)
      
    @removeButton.click => @model.remove()
    
    @model.on "invalid", => @showInstruction()
    
    super()
  
  setDisabled: ->
    return unless aqua.stripeKey  # Only disable for public registration
    for name, session of @model.sessions
      @disable(name, true) if session.disabled
  
  remove: -> @delegate.fadeOut(500, => @delegate.remove())
  
  setIndex: -> @find(".delegate-index").html @model.index
  
  setPrices: ->
    for session, price of @model.prices()
      discountNote = if @model.hasLevyPayerDiscount(session) then "; levy-payer rate" else ""
      @input(session).next(".price").html(price.toFixed(2) + discountNote)
    
  showInstruction: (show=true) ->
    @find(".session-instruction")[if show then "show" else "hide"]()
  
  find: (sel) -> @delegate.find(sel)


class Register
  
  url: "/conference/store"  # Admin only
  
  constructor: (@spec) ->
    {@registration, @onResponse} = @spec
  
  process: ->
    @post {registration: @registration.getProps()}
  
  post: (data) ->
    $.ajax
      type: "POST"
      url: @url
      data: JSON.stringify(data)  # Needed to ensure booleans handled correctly
      success: (response) => @onResponse(response)
      error: (response) => @onResponse(response)
      dataType: 'json'
      contentType: 'application/json'  # Needed to ensure booleans handled correctly
      


class Update
  
  url: "/conference"  # Admin only
  
  constructor: (@spec) ->
    {@id, @registration, @onResponse} = @spec
  
  process: ->
    @put @id, {registration: @registration.getProps()}
  
  put: (id, data) ->
    $.ajax
      type: "PUT"
      url: @url+"/"+id
      data: JSON.stringify(data)  # Needed to ensure booleans handled correctly
      success: (response) => @onResponse(response)
      error: (response) => @onResponse(response)
      dataType: 'json'
      contentType: 'application/json'  # Needed to ensure booleans handled correctly


class Stripe extends Register
  
  url: "/conference-pay"
  
  popup:
    name: "Registration Fee"
    description: "NZ Aquaculture Conference"
    image: "https://www.aqua.org.nz/img/aqnz-logo-large.png"
      # 'https://stripe.com/img/documentation/checkout/marketplace.png'
    currency: "nzd"
  
  constructor: (@spec) ->
    
    {@key, @registration, @onToken, @onResponse} = @spec
    
    @stripe = StripeCheckout.configure
      key: @key
      image: @popup.image
      locale: "auto"
      # panelLabel: "Pay"
      token: (token) => @process(token)
      
    # Close Checkout on page navigation:
    window.addEventListener 'popstate', => @stripe.close()
    
  open: ->
    
    email = @registration.email
    amount = 100*@registration.price()  # cents
    
    @stripe.open
      email: email
      name: @popup.name
      description: @popup.description
      amount: amount
      currency: @popup.currency
      
  process: (token) ->
    @onToken?(token)
    @post
      stripeToken: token.id
      registration: @registration.getProps()
      price: @registration.price()  # Should be used only to verify calculated price at server


class Confirmation
  
  # TODO: show registration summary and say email sent
  
  contentArea: $ ".conference-content"
  registrationArea: $ ".registration"
  registerButton: $ ".register-button"
  registrationProcessing: $ ".registration-processing"
  #registrationTotal: $ ".registration-total"
  payStatus: $ ".pay-status"
  
  constructor: (@spec) ->
    {@registration} = @spec
  
  display: (response) ->
    console.log "response", response
    @processing false
    if response.status is "Success"
      @confirmation response
    else
      @error response.responseJSON.status
  
  processing: (token) ->
    processing = if token then true else false
    @registrationProcessing[if processing then "show" else "hide"]()
    @registerButton.attr "disabled", processing
    
  confirmation: (response) ->
    {confirmation, registration} = response  # TODO: won't need registration
    @registrationArea.html confirmation
    window.onbeforeunload = null
  
  error: (status) ->
    @payStatus.html status
    @payStatus.show()
    
  clear: ->
    @payStatus.hide()
    @payStatus.empty()


class TestMode
  
  constructor: (@registration) ->
    
    @set "name", "Martin Clark"
    @set "email", "martin.clark@haulashore.com"
    @set "organisation", "Haulashore"
    @set "address", "61 Brook St\nNelson 7010"
    @set "sector", "Service Provider"
    @sd "sameAsContact", true
    @sd "confDay", true
  
  set: (p, v) -> @registration.set p, v
  
  sd: (p, v, n=0) -> @registration.delegates[n].set p, v


class PublicCreate
  
  showRegButton: $ ".show-registration-button"
  registrationForm: $ ".registration-form"
  testMode: false #aqua.envLocal
  
  constructor: (@spec) ->
    
    {@registration} = @spec
    
    @regForm = new RegistrationForm
      model: @registration
      register: =>
          @confirmation.clear()
          @stripe.open()
      
    @registration.addDelegate()
    
    @confirmation = new Confirmation {@registration, @regForm}
    
    @stripe = new Stripe
      key: aqua.stripeKey
      registration: @registration
      onToken: (token) => @confirmation.processing(token)
      onResponse: (response) => @confirmation.display(response)
      
    #@showRegButton.click => @start()
    @registrationForm.show()
    
    if @testMode
      #@start()
      new TestMode @registration
    
  start: ->
    @showRegButton.fadeOut 400, => @registrationForm.fadeIn(800)


class Admin
  
  buttonLabel: "Register"
  registrationForm: $ ".registration-form"
  successPage: "/conference/registrations"
  error: "Error"  # Override in subclass
  testMode: false #aqua.envLocal
  
  constructor: (@spec) ->
    
    {@registration, @model} = @spec
    
    @regForm = new RegistrationForm
      model: @registration
      buttonLabel: @buttonLabel
      register: => @register.process()
    
    @registrationForm.show()
    
    @init()
    
  init: ->
    # Override in subclass
    @register = process: ->
    
  done: (response) ->
    if response.status is "Success"
      window.onbeforeunload = null
      location = @successPage
      location += "##{@model.id}" if @model?.id
      window.location = location
    else
      alert(@error)


class AdminCreate extends Admin
  
  buttonLabel: "Register"
  error: "Error creating registration record"
  
  init: ->
    
    @registration.addDelegate()
    
    @register = new Register
      registration: @registration
      onResponse: (response) => @done(response)
    
    if @testMode
      new TestMode @registration


class AdminEdit extends Admin
  
  buttonLabel: "Update"
  error: "Error editing registration record"
  deleteButton: $ ".delete-button"
  deleteUrl: "/conference"
  
  init: ->
    
    @registration.setModel @model
    
    @register = new Update
      id: @model.id
      registration: @registration
      onResponse: (response) => @done(response)
    
    @deleteButton.show()
    
    @deleteButton.click =>
      $.ajax
        type: "DELETE"
        url: "#{@deleteUrl}/#{@model.id}"
        success: (response) => window.location = @successPage


class App
  
  constructor: ->
    
    console.log "aqua", aqua
    
    @setup()
    
    model = aqua.model
    isAdmin = model or not aqua.stripeKey
    
    @registration = new Registration
      year: aqua.year
      sessions: aqua.sessions
      marineFarmerLevyPayer: aqua.marineFarmerLevyPayer
      isAdmin: isAdmin
    
    if isAdmin
      if model
        new AdminEdit {@registration, model}
      else
        new AdminCreate {@registration}
    else
      new PublicCreate {@registration}
    
    # Enable navigation prompt
    @registration.on "change", => window.onbeforeunload = -> true
    @registration.on "changeDelegate", => window.onbeforeunload = -> true
  
  setup: ->
    
    window.console ?= {}
    console.log ?= ->
    
    $.ajaxSetup
      headers:
        "X-CSRF-TOKEN": $("meta[name='csrf-token']").attr("content")


window.aqua ?= {}
window.aqua.Registration = Registration  # For tests

new App unless window.aqua.test
